import * as yup from "yup";
import { clientDetailsFormExcludingPricingPlan } from "../../sharedFormSchema";

export const getEditClientForm = (
  isLinkedToStripe: boolean,
  isLinkedToHubspot: boolean,
) => {
  return clientDetailsFormExcludingPricingPlan.concat(
    getPricingPlanSchema(isLinkedToStripe, isLinkedToHubspot),
  );
};

export const getPricingPlanSchema = (
  isLinkedToStripe: boolean,
  isLinkedToHubspot: boolean,
) => {
  return yup.object({
    "client-pricing-plan": yup.string().test({
      name: "pricing-plan",
      message: "Client must be linked to Stripe to select this plan",
      test: function (value) {
        const paidPlans = ["starter", "standard", "complete"];
        const movingToPaid = paidPlans.includes(value as string);

        if (!isLinkedToHubspot && !isLinkedToStripe && movingToPaid) {
          return this.createError({
            message:
              "Client must be linked to Hubspot and Stripe to upgrade to, or downgrade from a paid plan.",
          });
        }

        if (!isLinkedToHubspot) {
          return this.createError({
            message:
              "Client must be linked to Hubspot to upgrade to, or downgrade from a plan.",
          });
        }

        if (movingToPaid && !isLinkedToStripe) {
          return this.createError({
            message:
              "Client must be linked to Stripe to upgrade to, or downgrade from a paid plan.",
          });
        }
        return true;
      },
    }),
    "client-billing-interval": yup
      .string()
      .when("client-pricing-plan", {
        is: (value: unknown) => {
          const paidPlans = ["starter", "standard", "complete", "enterprise"];
          type PricingPlan = (typeof paidPlans)[number];
          return paidPlans.includes(value as PricingPlan);
        },
        then: (schema) => schema.required("Billing interval is required"),
      })
      .nullable(),
  });
};
